import { useState } from 'react';
import type { UserChangePasswordRequest, UserChangePasswordResponse } from 'vopay';
import { api } from '@/services/api.config';

export default function useChangeUserPassword() {
  const [submitting, setSubmitting] = useState(false);

  async function changeUserPassword(params: UserChangePasswordRequest): Promise<UserChangePasswordResponse> {
    try {
      setSubmitting(true);
      const res = await api.postUserChangePassword(params);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      return res;
    } catch (error) {
      console.error('Change user password failed:', error);
      throw error;
    } finally {
      setSubmitting(false);
    }
  }

  return { submitting, changeUserPassword };
}
